<template>
  <div class="cart-footer" v-if="cartCount > 0">
    <div class="left">
      <i class="el-icon-shopping-cart-2"></i>
      <span>
        已选资源 <b>{{ cartCount }}</b> 个
        合计 <b>{{ cartTotal.toFixed(2) }}</b> 元
        余额 <b>{{ balance.toFixed(2) }}</b> 元
      </span>
    </div>
    <div class="right">
      <el-button type="danger" size="small" @click="handleRecharge">充值</el-button>
      <el-button type="danger" size="small" @click="clearCart">清除媒体</el-button>
      <el-button type="primary" size="small" @click="$router.push('/media-write')">填写文案</el-button>
      <el-button size="small" @click="handleExportCart">导出已选资源</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import * as XLSX from 'xlsx'
import { getMediaDetail, clearCart, getAuthInfo } from '@/api'
export default {
  name: 'CartBar',
  data() {
    return {
      pendingRecharge: false,
      balance: 0,
    }
  },
  computed: {
    ...mapGetters(['cartCount', 'cartTotal', 'cartItems', 'isLoggedIn'])
  },
  watch: {
    // 未登录时点了充值：登录成功后自动跳到在线充值页
    isLoggedIn(val) {
      if (val) {
        this.loadBalance()
        if (this.pendingRecharge) {
          this.pendingRecharge = false
          this.goRecharge()
        }
      } else {
        this.balance = 0
      }
    }
  },
  created() {
    this.loadBalance()
  },
  methods: {
    ...mapMutations(['CLEAR_CART', 'SET_LOGIN_DIALOG']),
    async loadBalance() {
      if (!this.isLoggedIn) {
        this.balance = 0
        return
      }
      try {
        const info = await getAuthInfo()
        this.balance = Number(info.balance) || 0
      } catch (e) {
        console.error('获取余额失败', e)
      }
    },
    goRecharge() {
      this.$router.push({ path: '/user-center', query: { menu: 'recharge' } }).catch(() => {})
    },
    handleRecharge() {
      // 未登录：先弹登录框，登录成功后自动跳转
      if (!this.isLoggedIn) {
        this.pendingRecharge = true
        this.SET_LOGIN_DIALOG({ visible: true, message: '请先登录后再进行充值' })
        return
      }
      this.goRecharge()
    },
    async clearCart() {
      try {
        await clearCart()
        this.CLEAR_CART()
        this.$message.success('购物车已清空')
      } catch (e) {
        this.$message.error(e.message || '清空失败')
      }
    },
    async handleExportCart() {
      const cartItems = this.cartItems
      if (!cartItems || cartItems.length === 0) {
        this.$message.warning('购物车为空，请先添加资源')
        return
      }
      try {
        this.$message.info('正在导出，请稍候...')
        const rows = []
        for (const item of cartItems) {
          try {
            const detail = await getMediaDetail({ id: item.id })
            if (detail) {
              rows.push({
                '名称': detail.name || '',
                '类型': detail.mediaType ? detail.mediaType.name : '',
                '门户': detail.mediaPortal ? detail.mediaPortal.name : '',
                '价格': detail.show_price || detail.price,
                '收录效果': detail.aiCollect ? detail.aiCollect.name : '',
                '收录情况': detail.newsCollect ? detail.newsCollect.name : '',
                'PC权重': detail.pc_weight,
                '移动权重': detail.mobile_weight,
                '地区': detail.region ? detail.region.proname : '',
                '周末发布': detail.weekend_publish ? '可发' : '不可发',
                '联系方式': detail.contact_allowed ? '可带' : '不可带',
                '特殊行业': detail.specialIndustry ? detail.specialIndustry.name : '',
                '描述': detail.desc || '',
              })
            }
          } catch (e) {
            console.error('获取媒体详情失败', e)
          }
        }
        if (rows.length === 0) {
          this.$message.warning('没有可导出的数据')
          return
        }
        const ws = XLSX.utils.json_to_sheet(rows)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, '已选资源')
        XLSX.writeFile(wb, '已选资源导出.xlsx')
        this.$message.success('导出成功')
      } catch (e) {
        console.error('导出失败', e)
        this.$message.error('导出失败')
      }
    }
  }
}
</script>

<style scoped>
.cart-footer {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 92%;
  max-width: 780px;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 99;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.16);
  animation: slideUp 0.3s ease;
}
@keyframes slideUp {
  from { transform: translate(-50%, 120%); }
  to { transform: translate(-50%, 0); }
}
.cart-footer .left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #3a3a3c;
}
.cart-footer .left i {
  font-size: 22px;
  color: #0071e3;
}
.cart-footer b {
  color: #ff3b30;
  margin: 0 4px;
  font-size: 15px;
}
.cart-footer .right {
  display: flex;
  gap: 8px;
}
.cart-footer .right .el-button {
  height: 34px;
  line-height: 32px;
  padding: 0 16px;
  border-radius: 10px;
}
</style>
